// extracted by mini-css-extract-plugin
export var activeNavItem = "Header-module--active-nav-item--ZXyel";
export var altHeader = "Header-module--alt-header--6jUsn";
export var emph = "Header-module--emph--MSTmt";
export var header = "Header-module--header--3ERvK";
export var navItem = "Header-module--nav-item--ROEzv";
export var navList = "Header-module--nav-list--qf023";